import React from 'react'
import { CButton, CModal, CModalBody, CModalHeader, CModalTitle, CModalFooter } from '@coreui/react';
import { Button, Flex, Input,  Select,  Typography, Upload } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { galeryAction } from 'src/store/Slices/Administrator/GalerySlice';
import { getClubs } from 'src/store/Slices/DropDownSlice';
import { UploadOutlined } from '@ant-design/icons';
import { openNotification } from 'src/components/helpers/notification';

const AddEditGaleryModal = ({ visible, setVisible, galeryInfo, setPage, setPageSize }) => {

    const dispatch = useDispatch()

    const [name, setName] = useState()
    const [club, setClub] = useState()
    const [imgUrl, setImgUrl] = useState()
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false)

    const clubs = useSelector(state => state.DropDownSlice.clubs)


    useEffect(() => {
        setName()
        setClub()
        setImgUrl()
        setFileList([])
    }, [visible.flag])


    useEffect(() => {
        if (visible.flag === 'edit') {
            setName(galeryInfo?.name)
            setClub(clubs?.data?.value.find(el => el.label === galeryInfo?.clubName)?.value)
            setImgUrl(galeryInfo?.imageUrl?.props?.src)
            setFileList([])
        }
    }, [visible, galeryInfo, clubs])

    useEffect(() => {
        if (visible.flag === 'edit') {
            dispatch(getClubs())
        }
    }, [visible])

    const onClickSubmit = () => {
        const formData = new FormData();
        fileList.forEach((file) => {
            formData.append('imageFile', file);
        });
        formData.append('id', visible.flag !== 'add' ? galeryInfo.id : undefined)
        formData.append('name', name)
        formData.append('clubId', club)
        formData.append('imageUrl', imgUrl)
        setUploading(true)
        dispatch(galeryAction({
            flag: visible.flag === 'add' ? 'put' : 'post', value: formData
        })).then(() => {
            dispatch(galeryAction({ flag: 'get' })).then(() => {
                setVisible({ open: false, flag: '' })
                setPage(1)
                setPageSize(20)
                setUploading(false)
            })
        })
    }

    const handleChange = (info) => {
        if (info.fileList.length === 0) {
            setFileList([])
        } else {
            let newFileList = [...fileList];
            newFileList = newFileList.slice(-1);

            setFileList(newFileList);
        }
 
    };

    const props = {
        onRemove: () => {
            setFileList([])
        },
        onChange: handleChange,
        beforeUpload: (file) => {
            if (file.size > 1048576) {
                openNotification({
                    type: 'error',
                    message: 'Размер файла должен быть меньше одного мегабайта'
                })
                return false
            }
            setFileList([...fileList, file]);
            return false;
        },
        fileList,
    };


    return (
        <CModal
            alignment="center"
            visible={visible.open}
            aria-labelledby="VerticallyCenteredExample"
            onClose={() => { setVisible({ open: false, flag: '' }) }}
            keyboard={true}
        >
            <CModalHeader>
                <CModalTitle id="VerticallyCenteredExample">{
                    visible.flag === 'add' ? 'Добавить галерею' : 'Редактировать галерею'
                }</CModalTitle>
            </CModalHeader>
            <CModalBody style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>

                <Flex vertical gap={16} style={{ marginTop: '20px' }}>
                    <>
                        <div>
                            <Typography.Title level={5}>Наименование</Typography.Title>
                            <Input
                                value={name}
                                onChange={e => setName(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Клуб</Typography.Title>
                            <Select
                                placeholder='Выбрать'
                                style={{width: '100%'}}
                                value={club}
                                onChange={e => setClub(e)}
                                onClick={() => {visible.flag === 'add' && dispatch(getClubs())}}
                                options={clubs?.data?.value}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Ссылка на изображение</Typography.Title>
                            <Input
                                value={imgUrl}
                                onChange={e => setImgUrl(e.currentTarget.value)}
                            />
                        </div>
                        <div>
                            <Typography.Title level={5}>Изображение (размер меньше 1 МБ)</Typography.Title>
                            <Upload accept='.png,.jpg,.jpeg' {...props}>
                                <Button icon={<UploadOutlined />}>Выберите файл</Button>
                            </Upload>
                        </div>
                    </>
                </Flex>

            </CModalBody>
            <CModalFooter>
                <CButton
                    onClick={() => { setVisible({ open: false, flag: '' }) }}
                    className='text-light'
                    color="secondary"
                >
                    Закрыть
                </CButton>
                <CButton disabled={uploading} onClick={onClickSubmit} className='text-light'>
                    {visible.flag === 'add' ? 'Добавить' : 'Редактировать'}
                </CButton>
            </CModalFooter>
        </CModal>
    )
}

export default AddEditGaleryModal